import React from "react";
import ColorPicker from "../../../assets/ColorPicker";
import { rgbToString } from "../../../helpers";
import ShopPreview from "../../../assets/ShopPreview";

export default function ColorSection({ values, onChange }) {

	return <>
		<div className="details">
			Now for some more fun stuff.
			<br /><br />
			Pick a feature colour. This shows in multiple places on the page as a highlight, and really helps to bring the brand together. Make sure that the colour you pick contrasts well with white.
			<br/><br/>
			Scroll down a little to see a preview of what your shop will look like.
		</div>
		{/* Feature Color 1 */}
		<div>
			<div className="inner">
				<ColorPicker
					color={values.featureColor1 || "#CE003B"}
					onChange={featureColor1 => onChange({ featureColor1: rgbToString(featureColor1.rgb) })}
				/>
			</div>
		</div>
		{/* Feature Color 2 */}
		{/* <div style={{ minWidth: "250px" }}>
			<h3>Color 2</h3>
			<div className="details">
				For the text that sits over your first colour.
				</div>
			<div className="inner">
				<ColorPicker
					color={values.featureColor2 || "#FFFFFF"}
					onChange={featureColor2 => onChange({ featureColor2: rgbToString(featureColor2.rgb) })}
				/>
			</div>
		</div> */}
		<br />
		<div>
			<h3>Happy with your pick?</h3>
			<div className="details" style={{ marginBottom: 10 }}>
				Here's an approximation of what it will look like.
			</div>
			<ShopPreview {...values} />
			<br />
			<div className="details">
				You can always change it later in your account.
			</div>
		</div>
		<br />
	</>
}


